/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Participant } from './Participant';
import {
    ParticipantFromJSON,
    ParticipantFromJSONTyped,
    ParticipantToJSON,
} from './Participant';

/**
 * Represents a Transcript
 * @export
 * @interface GetTranscriptResponseContent
 */
export interface GetTranscriptResponseContent {
    /**
     * Associated contact id
     * @type {string}
     * @memberof GetTranscriptResponseContent
     */
    contactId: string;
    /**
     * Amazon connect contact channel
     * @type {string}
     * @memberof GetTranscriptResponseContent
     */
    channel: string;
    /**
     * 
     * @type {Participant}
     * @memberof GetTranscriptResponseContent
     */
    participant: Participant;
    /**
     * The string content for the transcript
     * @type {string}
     * @memberof GetTranscriptResponseContent
     */
    content: string;
    /**
     * Time at which this transcript started relative to the start of the contact
     * @type {number}
     * @memberof GetTranscriptResponseContent
     */
    startOffset: number;
    /**
     * Time at which this transcript finished relative to the start of the contact
     * @type {number}
     * @memberof GetTranscriptResponseContent
     */
    endOffset: number;
    /**
     * The time at which the resource was created
     * @type {number}
     * @memberof GetTranscriptResponseContent
     */
    createdAt: number;
    /**
     * The time of the most recent update
     * @type {number}
     * @memberof GetTranscriptResponseContent
     */
    updatedAt: number;
    /**
     * Identifier for a transcript
     * @type {string}
     * @memberof GetTranscriptResponseContent
     */
    transcriptId: string;
}


/**
 * Check if a given object implements the GetTranscriptResponseContent interface.
 */
export function instanceOfGetTranscriptResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactId" in value;
    isInstance = isInstance && "channel" in value;
    isInstance = isInstance && "participant" in value;
    isInstance = isInstance && "content" in value;
    isInstance = isInstance && "startOffset" in value;
    isInstance = isInstance && "endOffset" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "transcriptId" in value;

    return isInstance;
}

export function GetTranscriptResponseContentFromJSON(json: any): GetTranscriptResponseContent {
    return GetTranscriptResponseContentFromJSONTyped(json, false);
}

export function GetTranscriptResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTranscriptResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'channel': json['channel'],
        'participant': ParticipantFromJSON(json['participant']),
        'content': json['content'],
        'startOffset': json['startOffset'],
        'endOffset': json['endOffset'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'transcriptId': json['transcriptId'],
    };
}

export function GetTranscriptResponseContentToJSON(value?: GetTranscriptResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactId': value.contactId,
        'channel': value.channel,
        'participant': ParticipantToJSON(value.participant),
        'content': value.content,
        'startOffset': value.startOffset,
        'endOffset': value.endOffset,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'transcriptId': value.transcriptId,
    };
}

